import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import successIcon from '../assets/snackbar/success.svg';
import errorIcon from '../assets/snackbar/error.svg';
import closeIcon from '../assets/snackbar/close.svg';

const SuccessIcon = () => (
  <div className='success_icon'>
    <img src={successIcon} alt='success'/>
  </div>
);
const ErrorIcon = () => (
  <div className='error_icon'>
    <img src={errorIcon} alt='success'/>
  </div>
);
const CloseIcon = ({ onClose }) => (
  <div className='close_icon' onClick={onClose}>
    <img src={closeIcon} alt='success'/>
  </div>
);

const SnackbarContext = createContext();

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) throw new Error('useSnackbar must be used inside SnackbarProvider');
  return context;
};

export const SnackbarProvider = ({ children }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('success');

  const showSnackbar = (msg, variant = 'success') => {
    setMessage(msg);
    setType(variant);
    setOpen(true);
  };

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar
        open={open}
        className='snack_bar'
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          icon={type === 'success' ? <SuccessIcon /> : <ErrorIcon />}
          className='snack_alert'
          action={<CloseIcon onClose={handleClose} />}
          onClose={handleClose}
          severity={type}
          sx={{ width: '100%' }}
        >
          <h3 className='snack_title'>{type === 'success' ? t('Done!') : t('Error!')}</h3>
          <p className='snack_text'>{message}</p>
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
